import React, { useEffect, useState } from "react";
import { getTeamSettings, setTeamSettings } from "../lib/api";
import { Button } from "../components/ui/button";
import { ShieldCheck, Mail, Save } from "lucide-react";
import { toast } from "sonner";
import { AiEngineCard } from "../components/AiEngineCard";
import { InstagramConnectCard } from "../components/InstagramConnectCard";
import { EmailListCard } from "../components/EmailListCard";
import { AuthEventsCard } from "../components/AuthEventsCard";
import { useAuth } from "../context/AuthContext";
import { Unlock } from "lucide-react";

export default function Settings() {
  const { authRequired } = useAuth();
  const [allowed, setAllowed] = useState([]);
  const [baseEmails, setBaseEmails] = useState([]);
  const [team, setTeam] = useState([]);
  const [newAllowed, setNewAllowed] = useState("");
  const [newTeam, setNewTeam] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getTeamSettings().then((d) => {
      setAllowed(d.allowed_emails || []);
      setBaseEmails(d.base_emails || []);
      setTeam(d.team_emails || []);
    }).catch((e) => console.warn("team settings load failed", e));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const res = await setTeamSettings({ allowed_emails: allowed, team_emails: team });
      setAllowed(res.allowed_emails); setTeam(res.team_emails);
      toast.success("Impostazioni salvate");
    } catch { toast.error("Errore nel salvataggio"); }
    finally { setSaving(false); }
  };

  return (
    <div className="fade-in max-w-3xl space-y-8 p-6 md:p-8">
      <div>
        <div className="label-caps text-primary">Team & Accessi</div>
        <h1 className="mt-1 font-heading text-4xl font-bold tracking-tight">Impostazioni</h1>
        <p className="mt-1 text-sm text-muted-foreground">Gestisci accessi, email automatiche, motore AI e collegamento Instagram, senza toccare il codice.</p>
      </div>

      <AiEngineCard />
      <InstagramConnectCard />

      {authRequired ? (
        <EmailListCard
          icon={ShieldCheck}
          title="Accesso Riservato"
          subtitle="Solo queste email Google possono accedere all'app. Le email 'base' vengono dalla configurazione server e sono sempre autorizzate."
          list={allowed} setList={setAllowed}
          value={newAllowed} setValue={setNewAllowed}
          testid="allowed"
          locked={baseEmails}
          warning={allowed.length === 0 ? "Lista vuota: al momento chiunque con un account Google potrebbe accedere." : null}
        />
      ) : (
        <div className="rounded-xl border border-yellow-500/30 bg-yellow-500/5 p-6" data-testid="auth-disabled-card">
          <div className="mb-1 flex items-center gap-2">
            <Unlock className="h-5 w-5 text-yellow-500" strokeWidth={1.75} />
            <h3 className="font-heading text-lg font-semibold">Login disattivato</h3>
          </div>
          <p className="text-sm text-muted-foreground">
            L'accesso con Google è spento: l'app si apre direttamente e <b>chiunque abbia il link</b> può vedere prospect, dati e impostazioni.
            Per riattivarlo basta impostare <code>AUTH_REQUIRED=true</code> nella configurazione del server: la lista email autorizzate qui sotto tornerà attiva.
          </p>
        </div>
      )}

      <EmailListCard
        icon={Mail}
        title="Destinatari Email"
        subtitle="Ricevono i promemoria follow-up (ogni mattina alle 10:00) e il report settimanale (venerdì 18:00)."
        list={team} setList={setTeam}
        value={newTeam} setValue={setNewTeam}
        testid="team"
      />

      <Button onClick={save} disabled={saving} size="lg" data-testid="save-settings-btn">
        <Save className="mr-2 h-4 w-4" /> {saving ? "Salvataggio..." : "Salva impostazioni"}
      </Button>

      {authRequired && <AuthEventsCard />}
    </div>
  );
}
